export class NavigationState {
    consent: boolean = false;
    honestyStatement: boolean = false;
    dashboard: boolean = false;
    hipaa: boolean = false;
    medicalQuestions: boolean = false;
    applicationReview: boolean = false;
    readyToBeContacted: boolean = false;
    phoneInterviewInstructions: boolean = false;
    identification

    honestyStatementEligible: boolean = false;
    hipaaEligible: boolean = false;
    medicalQuestionsEligible: boolean = false;
    applicationReviewEligible: boolean = false;
    identificationUploadEligible: boolean = false;
    readyToBeContactedEligible: boolean = false;

    honestyStatementCompleted: boolean = false;
    hipaaCompleted: boolean = false;
    medicalQuestionsCompleted: boolean = false;
    applicationReviewCompleted: boolean = false;
    identificationUploadCompleted: boolean = false;
    contactMeCompleted: boolean = false;
    medicalQuestionsAreBeingRetrieved: boolean = false;
    medicalQuestionsRetrievalComplete: boolean = false;
    readyToBeContactedComplete: boolean = false;

    lockApplicationSelection: boolean = false;
    electronicConsentReceived: boolean = false;
    honestyStatementChecked: boolean = false;

    disableAll: boolean = false;

    constructor() {
        this.resetNavigationState();
    }

    resetNavigationState() {
        this.honestyStatement = true;
        this.consent = false;
        this.dashboard = false;
        this.hipaa = false;
        this.medicalQuestions = false;
        this.applicationReview = false;
        this.identification = false;
        this.readyToBeContacted = false;
        this.phoneInterviewInstructions = false;

        this.honestyStatementEligible = true;
        this.lockApplicationSelection = false;
    }
}
